import Loading from "components/Loading"

import { ComponentProps } from "."
import {
  ErrorText,
  IconEndWrapper,
  IconStartWrapper,
  InfoText,
  Input,
  Label,
  SuccessText,
  Wrapper
} from "./styled"

const InputText = ({
  className,
  defaultValue,
  disabled,
  error,
  errorText,
  hasContent,
  iconEnd,
  iconStart,
  infoText,
  inputId,
  inputProps,
  isFullBorder,
  label,
  labelId,
  loading,
  max,
  min,
  name,
  onBlur,
  onChange,
  onClick,
  onInput,
  onKeyDown,
  ref,
  required,
  size,
  step,
  success,
  successText,
  type = "text",
  value
}: ComponentProps) => (
  <Wrapper className={className}>
    {iconStart ? <IconStartWrapper>{iconStart}</IconStartWrapper> : null}

    <Input
      {...inputProps}
      $error={error}
      $hasContent={hasContent}
      $hasIconStart={Boolean(iconStart)}
      $isFullBorder={isFullBorder}
      $loading={loading}
      $success={success}
      aria-invalid={error ? "true" : "false"}
      defaultValue={defaultValue}
      disabled={disabled}
      id={inputId}
      max={max}
      min={min}
      name={name}
      onBlur={onBlur}
      onChange={onChange}
      onClick={onClick}
      onInput={onInput}
      onKeyDown={onKeyDown}
      ref={ref}
      required={required}
      size={size}
      step={step}
      type={type}
      value={value}
    />

    <Label
      $hasIconStart={Boolean(iconStart)}
      $isFullBorder={isFullBorder}
      htmlFor={inputId}
      id={labelId}
    >
      {label}
    </Label>

    {iconEnd && Boolean(value) ? (
      <IconEndWrapper>{iconEnd}</IconEndWrapper>
    ) : null}

    {loading ? (
      <IconEndWrapper>
        <Loading />
      </IconEndWrapper>
    ) : null}

    {errorText ? <ErrorText role="alert">{errorText}</ErrorText> : null}

    {infoText ? <InfoText aria-live="polite">{infoText}</InfoText> : null}

    {successText ? (
      <SuccessText aria-live="polite">{successText}</SuccessText>
    ) : null}
  </Wrapper>
)

InputText.displayName = "InputText"

export default InputText
